import { z } from 'zod';

const num = () => z.coerce.number();
const numNull = () => z.union([z.coerce.number(), z.null()]);
const boolish = () => z.union([z.boolean(), z.coerce.number()]);

export const JitB2B2CVendorPackingSlaSummarySchema = z.array(z.object({
  due_scope_packages: num(),
  matured_due_packages: num(),
  packed_on_time_packages: num(),
  packed_late_packages: num(),
  open_overdue_packages: num(),
  closed_after_due_without_packed_packages: num(),
  missed_sla_packages: num(),
  vendor_packing_on_time_pct: numNull(),
  vendor_packing_missed_pct: numNull(),
  avg_pack_hours: numNull(),
  p75_pack_hours: numNull(),
  p95_pack_hours: numNull(),
  avg_delay_hours_for_missed: numNull(),
  p75_delay_hours_for_missed: numNull(),
  p95_delay_hours_for_missed: numNull(),
}));
export type JitB2B2CVendorPackingSlaSummary = z.infer<typeof JitB2B2CVendorPackingSlaSummarySchema>;

export const JitB2B2CVendorPackingSlaWeeklySchema = z.array(z.object({
  grain: z.string(),
  brand_name: z.string().nullable(),
  metric_week: z.string().nullable(),
  metric_week_end: z.string().nullable(),
  due_scope_packages: num(),
  matured_due_packages: num(),
  packed_on_time_packages: num(),
  missed_sla_packages: num(),
  packed_late_packages: num(),
  open_overdue_packages: num(),
  on_time_pct: numNull(),
  missed_pct: numNull(),
  avg_pack_hours: numNull(),
  p75_pack_hours: numNull(),
  p95_pack_hours: numNull(),
  avg_delay_hours_for_missed: numNull(),
  p95_delay_hours_for_missed: numNull(),
}));
export type JitB2B2CVendorPackingSlaWeekly = z.infer<typeof JitB2B2CVendorPackingSlaWeeklySchema>;

export const JitB2B2CVendorPackingSlaByBrandSchema = z.array(z.object({
  brand_name: z.string().nullable(),
  vendor_id: numNull(),
  vendor_name: z.string().nullable(),
  brand_manager: z.string().nullable(),
  due_scope_packages: num(),
  matured_due_packages: num(),
  packed_on_time_packages: num(),
  missed_sla_packages: num(),
  packed_late_packages: num(),
  open_overdue_packages: num(),
  on_time_pct: numNull(),
  missed_pct: numNull(),
  avg_pack_hours: numNull(),
  p75_pack_hours: numNull(),
  p95_pack_hours: numNull(),
  avg_delay_hours_for_missed: numNull(),
  max_delay_hours_for_missed: numNull(),
  oldest_open_overdue_due_on: z.string().nullable(),
  snapshot_at: z.string().nullable(),
}));
export type JitB2B2CVendorPackingSlaByBrand = z.infer<typeof JitB2B2CVendorPackingSlaByBrandSchema>;

export const JitB2B2CVendorPackingSlaRawSchema = z.array(z.object({
  vendor_packing_due_date: z.string().nullable(),
  vendor_packing_due_on: z.string().nullable(),
  vendor_packing_due_week: z.string().nullable(),
  snapshot_at: z.string().nullable(),
  brand_name: z.string().nullable(),
  brand_manager: z.string().nullable(),
  vendor_id: numNull(),
  vendor_name: z.string().nullable(),
  package_id: numNull(),
  sales_channel_order_id: z.string().nullable(),
  order_id: numNull(),
  package_current_status: z.string().nullable(),
  lifecycle_stage: z.string().nullable(),
  stage_specific_action_bucket: z.string().nullable(),
  stage_specific_action_owner: z.string().nullable(),
  stage_specific_action_label: z.string().nullable(),
  package_ready_to_ship_on: z.string().nullable(),
  jit_vendor_tat_days: numNull(),
  vendor_packing_tat_bucket: z.string().nullable(),
  vendor_packing_actual_hours: numNull(),
  vendor_packing_effective_delay_hours: numNull(),
  vendor_packing_outcome: z.string().nullable(),
  vendor_ready_jit_tat_status: z.string().nullable(),
  is_vendor_packing_sla_scope: boolish(),
  is_vendor_packing_due_matured: boolish(),
  is_vendor_packing_on_time: boolish(),
  is_vendor_packing_late: boolish(),
  is_vendor_packing_open_overdue: boolish(),
  is_vendor_packing_sla_missed: boolish(),
  open_vendor_packing_overdue_days: numNull(),
  courier_partner_name: z.string().nullable(),
  courier_tracking_id: z.string().nullable(),
  tracking_url: z.string().nullable(),
  total_quantity: numNull(),
  total_amount: numNull(),
  placed_date: z.string().nullable(),
  package_customer_delivered_on: z.string().nullable(),
}));
export type JitB2B2CVendorPackingSlaRaw = z.infer<typeof JitB2B2CVendorPackingSlaRawSchema>;
